import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { dashboardQueryOptions } from '../../../../api/admin';
import { DashboardTab } from '../../../../components/admin/DashboardTab';

export const Route = createFileRoute('/_auth/admin/dashboard/')({
  component: AdminDashboardPage,
});

function AdminDashboardPage() {
  const { t } = useTranslation();
  const { data, isLoading, isFetching, dataUpdatedAt, refetch } = useQuery(
    dashboardQueryOptions(),
  );
  return (
    <section className="epi-card tone-blue">
      <div className="epi-card-head">
        <span className="num">{t('admin.dashboard.cardHead.num')}</span>
        <span className="title">{t('admin.dashboard.cardHead.title')}</span>
        <span className="meta">{t('admin.dashboard.cardHead.meta')}</span>
      </div>
      <DashboardTab
        data={data}
        isLoading={isLoading}
        isFetching={isFetching}
        dataUpdatedAt={dataUpdatedAt}
        onRefresh={() => void refetch()}
      />
    </section>
  );
}
